import { useMembers } from "@/queries/organization-queries";
import { useAuthenticatedUser } from "@/queries/user-queries";
import type { PlainMessage } from "@bufbuild/protobuf";
import type { OrganizationMember } from "gitpod-next-api/gitpod/v1/organization_pb";

export function useCurrentMember(): {
    currentMember?: PlainMessage<OrganizationMember>;
    error: Error | null;
    isPending: boolean;
} {
    const { data: user, isPending: isPendingUser, error: authenticatedUserError } = useAuthenticatedUser();
    const { data: membersData, isPending: isPendingMembers, error: membersError } = useMembers();
    const currentMember = membersData?.members.find((m) => m.userId === user?.id);

    return {
        currentMember: currentMember,
        error: authenticatedUserError || membersError,
        isPending: isPendingUser || isPendingMembers,
    };
}
